/*
 * @Author: yeyimei
 * @Date: 2022-09-22 17:09:10
 * @LastEditTime: 2024-03-15 14:25:49
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\router\routers.js
 */
const routerList = []

// 自动引入分类路由文件
const importRoutes = (r) => {
  r.keys().forEach((key) => {
    if (r(key).default instanceof Array) {
      r(key).default.forEach((item) => {
        routerList.push(item)
      })
    } else {
      if (Object.keys(r(key).default).length) {
        routerList.push(r(key).default)
      }
    }
  })
}

importRoutes(require.context('./', false, /\.routes\.js/))
export default [
  ...routerList,
  {
    path: '/',
    name: 'home',
    // component: () => import( /*webpackChunkName: 'home'*/ '@/components/parentCpn/index.vue'),
    component: () => import(/*webpackChunkName: 'home'*/ '@/views/home.vue'),
  },
  {
    path: '/index',
    name: 'index',
    component: () => import(/*webpackChunkName: 'home'*/ '@/views/index.vue'),
  },

  {
    path: '/login',
    name: 'login',
    component: () => import(/*webpackChunkName: 'login'*/ '@/views/login.vue'), //登录页面
  },
  {
    path: '/parentCpn',
    name: 'parentCpn',
    component: () =>
      import(/*webpackChunkName: 'home'*/ '@/components/parentCpn/index.vue'),
    redirect: '/parentCpn/welfare',
    children: [
      {
        path: 'welfare',
        name: 'welfare',
        component: () =>
          import(
            /*webpackChunkName: 'home'*/ '@/views/welfare/index-preview.vue'
          ),
        meta: {
          title: '邦客惠会员商城',
          showName: true,
        },
      },
      // {
      //   path: "welfare1",
      //   name: "welfare1",
      //   component: () =>
      //     import(/*webpackChunkName: 'home'*/ "@/views/welfare1/index.vue"),
      // },
      {
        path: 'mine',
        name: 'mine',
        component: () =>
          import(/* webpackChunkName: "mine" */ '@/views/mine/index.vue'),
        // import(/* webpackChunkName: "mine" */ '@/views/mine/index1.vue'),
        meta: {
          title: '我的',
        },
      },
      {
        path: 'tab-services',
        name: 'tab-services',
        component: () =>
          import(
            /* webpackChunkName: "mine" */
            '@/views/services/tab-services.vue'
          ),
        meta: {
          title: '全部服务',
        },
      },
      {
        path: 'classify',
        name: 'classifyOne',
        component: () =>
          import(
            /* webpackChunkName: "dine-libertinism" */
            '@/views/classify/classify.vue'
          ),
        meta: {
          title: '会员充值',
        },
      },

      {
        path: 'activities',
        name: 'activities',
        component: () =>
          import(
            /* webpackChunkName: "distribution-rules" */
            '@/views/activities/index.vue'
          ), //最新活動頁面
        meta: {
          title: '最新活动',
        },
      },
    ],
  },
  {
    path: '/recharge-notice',
    name: 'recharge-notice',
    component: () =>
      import(/* webpackChunkName: "mine" */ '@/views/mine/recharge-notice.vue'),
    meta: {
      title: '订单提醒设置',
    },
  },
  {
    path: '/dine-libertinism',
    name: 'dine-libertinismtwo',
    component: () =>
      import(
        /* webpackChunkName: "dine-libertinism" */
        '@/views/advertPages/dine-libertinism/index.vue'
      ),
    meta: {
      keepAlive: true,
      title: '吃喝玩乐',
      showName: true,
    },
  },
  {
    path: '/advertPages/phone-recharge/recharge',
    name: 'phone-recharge',
    component: () =>
      import(
        /* webpackChunkName: "dine-libertinism" */
        '@/views/advertPages/phone-recharge/recharge.vue'
      ),
    meta: {
      // title: "话费预充-月中特惠",
      title: '话费预充',
      showName: true,
    },
  },
  {
    path: '/phone-feedback',
    name: 'phone-feedback',
    component: () =>
      import(
        /* webpackChunkName: "dine-libertinism" */
        '@/views/advertPages/phone-recharge/order-feedback.vue'
      ),
    meta: {
      title: '订单售后处理',
    },
  },
  {
    path: '/electricity-recharge',
    name: 'electricity-recharge',
    component: () =>
      import(
        /* webpackChunkName: "dine-libertinism" */
        '@/views/advertPages/electricity-recharge/electricity-recharge.vue'
      ),
    meta: {
      // title: "电费充值",
      title: '电费预充',
      showName: true,
    },
  },
  {
    path: '/electricity-often',
    name: 'electricity-often',
    component: () =>
      import(
        /* webpackChunkName: "dine-libertinism" */
        '@/views/advertPages/electricity-recharge/oftenNumber.vue'
      ),
    meta: {
      title: '电费常用号码',
    },
  },
  {
    path: '/electricity-feedback',
    name: 'electricity-feedback',
    component: () =>
      import(
        /* webpackChunkName: "dine-libertinism" */
        '@/views/advertPages/electricity-recharge/order-feedback.vue'
      ),
    meta: {
      title: '订单售后处理',
    },
  },
  {
    path: '/advertPages/classify/classify',
    name: 'classifytwo',
    component: () =>
      import(
        /* webpackChunkName: "dine-libertinism" */
        '@/views/advertPages/classify/classify.vue'
      ),
    meta: {
      title: '会员充值',
      showName: true,
    },
  },
  {
    path: '/classify-feedback',
    name: 'classify-feedback',
    component: () =>
      import(
        /* webpackChunkName: "dine-libertinism" */
        '@/views/advertPages/classify/order-feedback.vue'
      ),
    meta: {
      title: '订单售后处理',
    },
  },
  {
    path: '/disclaimer',
    name: 'disclaimer',
    component: () =>
      import(
        /* webpackChunkName: "disclaimer" */
        '@/views/mine/disclaimer.vue'
      ), //免责声明
    meta: {
      title: '免责声明',
    },
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () =>
      import(/* webpackChunkName: "aboutUs" */ '@/views/mine/aboutUs.vue'), //关于惠客邦
    meta: {
      title: '关于福利',
    },
  },
  {
    path: '/my-order',
    name: 'my-order',
    component: () =>
      import(
        /* webpackChunkName: "my-order" */
        '@/views/advertPages/my-order/my-order.vue'
      ), //我的订单页面
    meta: {
      title: '我的订单',
    },
  },
  {
    path: '/order-detail',
    name: 'order-detail',
    component: () =>
      import(
        /* webpackChunkName: "order-detail" */
        '@/views/advertPages/order-detail/order-detail.vue'
      ), //订单详情
    meta: {
      title: '订单详情',
    },
  },
  {
    path: '/ticket-verify',
    name: 'ticket-verify',
    component: () =>
      import(
        /* webpackChunkName: "ticket-verify" */
        '@/views/advertPages/order/ticket-verify.vue'
      ), //卷码核销
    meta: {
      title: '卷码核销',
    },
  },
  {
    path: '/goods-detail',
    name: 'goods-detail',
    component: () =>
      import(
        /* webpackChunkName: "goods-detail" */
        '@/views/advertPages/goods-detail/index.vue'
      ), //直充商品详情
    meta: {
      title: '商品详情',
      showName: true,
    },
  },
  {
    path: '/payment/wxpay',
    name: 'payment',
    component: () =>
      import(/* webpackChunkName: "payment" */ '@/views/payment/wxpay.vue'), //支付页面
    meta: {
      title: '支付',
    },
  },
  {
    path: '/select-city',
    name: 'select-city',
    component: () =>
      import(
        /* webpackChunkName: "select-city" */
        '@/views/advertPages/select-city/city.vue'
      ), //城市选择页面
    meta: {
      title: '城市选择',
    },
  },
  {
    path: '/setmeal-detail',
    name: 'setmeal-detail',
    component: () =>
      import(
        /* webpackChunkName: "setmeal-detail" */
        '@/views/advertPages/setmeal-detail/index.vue'
      ), //吃喝玩乐详情页面
    meta: {
      title: '套餐详情',
      showName: true,
    },
  },
  {
    path: '/apply-shop',
    name: 'apply-shop',
    component: () =>
      import(
        /* webpackChunkName: "apply-shop" */
        '@/views/advertPages/apply-shop/index.vue'
      ), //选择门店页面
    meta: {
      title: '选择门店',
    },
  },
  {
    path: '/confirm-order',
    name: 'confirm-order',
    component: () =>
      import(
        /* webpackChunkName: "confirm-order" */
        '@/views/advertPages/confirm-order/index.vue'
      ), //确认订单
    meta: {
      title: '确认订单',
    },
  },
  {
    path: '/switch-city',
    name: 'switch-city',
    component: () =>
      import(
        /* webpackChunkName: "switch-city" */
        '@/views/advertPages/switch-city/index.vue'
      ), //城市搜索页面
    meta: {
      title: '城市搜索',
    },
  },
  {
    path: '/apply-refund',
    name: 'apply-refund',
    component: () =>
      import(
        /* webpackChunkName: "apply-refund" */
        '@/views/advertPages/apply-refund/index.vue'
      ), //申请退款
    meta: {
      title: '申请退款',
    },
  },
  {
    path: '/live-hood',
    name: 'live-hood',
    component: () =>
      import(
        /* webpackChunkName: "live-hood" */
        '@/views/liveliHood/livelihood.vue'
      ), //民生网申-首页
    meta: {
      title: '免费领100元微信消费金',
    },
  },
  {
    path: '/exclusive',
    name: 'exclusive',
    component: () =>
      import(
        /* webpackChunkName: "exclusive" */
        '@/views/liveliHood/exclusive.vue'
      ), //民生网申-用户权益
    meta: {
      title: '用户权益',
    },
  },
  {
    path: '/explain',
    name: 'explain',
    component: () =>
      import(/* webpackChunkName: "explain" */ '@/views/liveliHood/explain.vue'), //民生网申-用户权益
    meta: {
      title: '活动说明',
    },
  },
  {
    path: '/search',
    name: 'search',
    component: () =>
      import(
        /* webpackChunkName: "live-hood" */
        '@/views/advertPages/search/search.vue'
      ), //商品搜索页面
  },
  {
    path: '/weapp',
    name: 'weapp',
    component: () =>
      import(
        /* webpackChunkName: "live-hood" */
        '@/views/advertPages/weapp/weapp.vue'
      ), //打开小程序
  },
  {
    path: '/cardlan',
    name: 'cardlan',
    component: () =>
      import(
        /* webpackChunkName: "aggregate" */
        '@/views/advertPages/aggregate/aggregate.vue'
      ), //聚合页
    meta: {
      title: '卡联科技',
    },
  },
  {
    path: '/business-ticket',
    name: 'business-ticket',
    component: () =>
      import(
        /* webpackChunkName: "distribution" */
        '@/views/advertPages/business-ticket/index.vue'
      ),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () =>
      import(
        /* webpackChunkName: "privacy" */
        '@/views/advertPages/privacy/privacy.vue'
      ), //隐私协议
    meta: {
      title: '用户隐私协议',
    },
  },
  {
    path: '/distribution',
    name: 'distribution',
    component: () =>
      import(
        /* webpackChunkName: "distribution" */
        '@/views/advertPages/distribution/index.vue'
      ), //分销中心首页
    meta: {
      // title: "自购省钱，分享赚钱",
      title: '提现中心',
      showName: true,
    },
  },

  {
    path: '/userInfo',
    name: 'userInfo',
    component: () =>
      import(/* webpackChunkName: "userInfo" */ '@/views/mine/userInfo.vue'), //个人信息页面
    meta: {
      title: '个人信息',
    },
  },
  {
    path: '/ranking',
    name: 'ranking',
    component: () =>
      import(
        /* webpackChunkName: "ranking" */
        '@/views/advertPages/distribution/ranking.vue'
      ), //月排行榜
    meta: {
      title: '活动排行榜',
    },
  },
  {
    path: '/distribution-goods',
    name: 'distribution-goods',
    component: () =>
      import(
        /* webpackChunkName: "ranking" */
        '@/views/advertPages/distribution/distribution-goods.vue'
      ), //分销商品
    meta: {
      title: '下单返现商品',
    },
  },
  {
    path: '/commission-record',
    name: 'commission-record',
    component: () =>
      import(
        /* webpackChunkName: "commission-record" */
        '@/views/advertPages/distribution/commission-record.vue'
      ), //佣金记录
    meta: {
      title: '余额动态',
    },
  },
  {
    path: '/extension-order',
    name: 'extension-order',
    component: () =>
      import(
        /* webpackChunkName: "extension-order" */
        '@/views/advertPages/distribution/extension-order.vue'
      ), //推广订单
    meta: {
      title: '推广订单',
    },
  },
  {
    path: '/dist/order-detail',
    name: 'dist-order-detail',
    component: () =>
      import(
        /* webpackChunkName: "extension-order" */
        '@/views/advertPages/distribution/order-detail.vue'
      ), //推广订单
    meta: {
      title: '订单详情',
    },
  },
  {
    path: '/extension',
    name: 'extension',
    component: () =>
      import(
        /* webpackChunkName: "extension" */
        '@/views/advertPages/distribution/extension.vue'
      ), //推广页面（海报生产保存）
  },
  {
    path: '/my-team',
    name: 'my-team',
    component: () =>
      import(
        /* webpackChunkName: "my-team" */
        '@/views/advertPages/distribution/myTeam.vue'
      ), //我的团队
    meta: {
      title: '我的团队',
    },
  },
  {
    path: '/my-team-ranking',
    name: 'my-team-ranking',
    component: () =>
      import(
        /* webpackChunkName: "my-team" */
        '@/views/advertPages/distribution/myTeamRanking.vue'
      ), //我的团队排名
    meta: {
      title: '我的团队排名',
    },
  },
  {
    path: '/my-business-card',
    name: 'my-business-card',
    component: () =>
      import(
        /* webpackChunkName: "my-team" */
        '@/views/advertPages/business-card/business-card.vue'
      ),
    meta: {
      title: '专属名片',
    },
  },
  {
    path: '/blurb',
    name: 'blurb',
    component: () =>
      import(
        /* webpackChunkName: "my-team" */
        '@/views/advertPages/business-card/someone-business-card.vue'
      ),
    meta: {
      title: '我的名片',
    },
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () =>
      import(
        /* webpackChunkName: "agreement" */
        '@/views/advertPages/distribution/agreement.vue'
      ), //同意协议与开通分销页面
    meta: {
      // title: '同意协议并开通分销'
      title: '同意协议并加入会员',
    },
  },
  {
    path: '/distribution-rules',
    name: 'distribution-rules',
    component: () =>
      import(
        /* webpackChunkName: "distribution-rules" */
        '@/views/advertPages/distribution/distribution-rules.vue'
      ), //分销规则
    meta: {
      title: '会员须知',
    },
  },
  {
    path: '/bank-list',
    name: 'bank-list',
    component: () =>
      import(
        /* webpackChunkName: "distribution-rules" */
        '@/views/advertPages/distribution/bank-list.vue'
      ), //银行卡列表
    meta: {
      title: '银行卡列表',
    },
  },
  {
    path: '/withdrawal',
    name: 'withdrawal',
    component: () =>
      import(
        /* webpackChunkName: "distribution-rules" */
        '@/views/advertPages/distribution/withdrawal.vue'
      ), //提现页面
    meta: {
      title: '提现',
    },
  },
  {
    path: '/withdrawal-record',
    name: 'withdrawal-record',
    component: () =>
      import(
        /* webpackChunkName: "distribution-rules" */
        '@/views/advertPages/distribution/withdrawal-record.vue'
      ), //提现记录
    meta: {
      title: '提现记录',
    },
  },
  {
    path: '/bank-edit',
    name: 'bank-edit',
    component: () =>
      import(
        /* webpackChunkName: "distribution-rules" */
        '@/views/advertPages/distribution/bank-edit.vue'
      ), //新增、编辑银行卡页面
    meta: {
      title: '新增/编辑提现银行卡',
    },
  },
  {
    path: '/withdrawal-detail',
    name: 'withdrawal-detail',
    component: () =>
      import(
        /* webpackChunkName: "distribution-rules" */
        '@/views/advertPages/distribution/withdrawal-detail.vue'
      ), //提现详情页面
    meta: {
      title: '提现详情',
    },
  },
  {
    path: '/withdrawal-detail',
    name: 'withdrawal-detail',
    component: () =>
      import(
        /* webpackChunkName: "distribution-rules" */
        '@/views/advertPages/distribution/withdrawal-detail.vue'
      ), //提现详情页面
    meta: {
      title: '提现详情',
    },
  },

  {
    path: '/services',
    name: 'services',
    component: () =>
      import(
        /* webpackChunkName: "distribution-rules" */
        '@/views/services/index.vue'
      ), //全部服务页面
    meta: {
      title: '全部服务',
    },
  },
  // {
  //   path: "/lowest-network",
  //   name: "lowest-network",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "distribution-rules" */
  //       "@/views/services/lowest-network.vue"
  //     ), //全网最低页面
  //   meta: {
  //     title: "全网最低",
  //   },
  // },
  {
    path: '/subscribe',
    name: 'subscribe',
    component: () =>
      import(
        /* webpackChunkName: "distribution-rules" */
        '@/views/mine/subscribe.vue'
      ), //关注公众号页面
    meta: {
      title: '关注公众号',
    },
  },
  {
    path: '/faqPage',
    name: 'faqPage',
    component: () =>
      import(
        /* webpackChunkName: "distribution-rules" */
        '@/views/mine/faqPage.vue'
      ),

    meta: {
      title: '常见问题',
    },
  },
  {
    path: '/maintain',
    name: 'maintain',
    component: () =>
      import(
        /* webpackChunkName: "distribution-rules" */
        '@/views/maintain.vue'
      ),

    meta: {
      title: '',
    },
  },

  {
    path: '/merge',
    name: 'merge',
    component: () =>
      import('@/views/advertPages/distribution/account-merge.vue'),
    meta: {
      title: '会员中心账号合并',
    },
  },
  {
    path: '/zszq',
    name: 'zszq',
    component: () => import('@/views/advertPages/zszq/index.vue'),
    meta: {
      title: '中山证券',
    },
  },
  {
    path: '/user-protocol',
    name: 'userProtocol',
    component: () => import('@/views/mine/user-protocol-list.vue'),
    meta: {
      title: '用户相关协议',
    },
  },
  {
    path: '/member',
    name: 'member',
    component: () => import('@/views/mine/member/member.vue'),
    meta: {
      title: '会员中心',
      showName: true,
    },
  },
  // {
  //   path: "/member-benefits",
  //   name: "memberBenefits",
  //   component: () => import("@/views/mine/member/member-benefits.vue"),
  //   meta: {
  //     title: "一元吃鸡",
  //     showName: true,
  //     keepAlive: true,
  //   },
  // },
  {
    path: '/member-benefits',
    name: 'memberBenefits',
    component: () => import('@/views/mine/member/member-activity.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/jump-other',
    name: 'jumpOther',
    component: () => import('@/views/jumpOther.vue'),
    meta: {
      title: '跳转',
    },
  },
  {
    path: '/user-subscribe',
    name: 'userSubscribe',
    component: () => import('@/views/subscribe/index.vue'),
    meta: {
      title: '订阅',
    },
  },
  {
    path: '/order-subscribe',
    name: 'orderSubscribe',
    component: () => import('@/views/subscribe/order.vue'),
    meta: {
      title: '',
    },
  },
]
